var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canBeValidated)?_c('div',[_c('b-link',{attrs:{"title":"Tiers non validé"},on:{"click":function($event){return _vm.showConfirmationModal()}}},[_c('i',{staticClass:"fas fa-fw fa-exclamation-triangle text-warning"})])],1):_c('div',[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":"Tiers non validé"}},[_c('i',{staticClass:"fas fa-fw fa-exclamation-triangle text-warning"})])
}]

export { render, staticRenderFns }